import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";

const RegisterStep3 = ({ onSubmit }) => {
  const initialValues = {
    businessName: "",
    phone: "",
    firstName: "",
    lastName: "",
    bookingSystem: "",
    email: "",
    password: "",
    agree: false,
  };

  const validate = (values) => {
    const errors = {};
    if (!values.businessName) errors.businessName = "Required";
    if (!values.phone) errors.phone = "Required";
    if (!values.firstName) errors.firstName = "Required";
    if (!values.lastName) errors.lastName = "Required";
    if (!values.bookingSystem) errors.bookingSystem = "Required";
    if (!values.email) errors.email = "Required";
    if (!values.password) errors.password = "Required";
    if (!values.agree) errors.agree = "You must agree to continue";
    return errors;
  };

  const handleSubmit = (values) => {
    onSubmit?.(values);
  };

  const bookingOptions = [
    { value: "", label: "How do you manage your bookings?" },
    { value: "pen_and_paper", label: "Pen and paper" },
    { value: "new_business", label: "New business" },
    { value: "timely", label: "Timely" },
    { value: "fresha", label: "Fresha (Shedule)" },
    { value: "shortcuts", label: "Shortcuts" },
    { value: "walk_ins", label: "Walk-ins" },
    { value: "other_software", label: "Other software" },
  ];

  return (
    <div className="min-h-screen bg-dry flex flex-col items-center justify-start pt-16 px-5">
      <h2 className="text-sm  text-text px-3 py-3">
        Nice. Let's get some details
      </h2>

      <Formik
        initialValues={initialValues}
        validate={validate}
        onSubmit={handleSubmit}
      >
        {({ errors, touched }) => (
          <Form className="w-full max-w-md bg-dry rounded-md p-6 shadow-md border border-drylight">
            {/* Business Name */}
            <div className="mb-4">
              <label className="block text-sm text-text mb-1">
                Business name{" "}
                {errors.businessName && touched.businessName && (
                  <span className="text-red-500">Required</span>
                )}
              </label>
              <Field
                name="businessName"
                className="w-full border border-dry bg-drydark text-white placeholder-gray-400 rounded-md p-3 text-sm"
              />
            </div>

            {/* Phone */}
            <div className="mb-4">
              <label className="block text-sm text-text mb-1">
                Phone{" "}
                {errors.phone && touched.phone && (
                  <span className="text-red-500">Required</span>
                )}
              </label>
              <Field
                name="phone"
                className="w-full border border-dry bg-drydark text-white placeholder-gray-400 rounded-md p-3 text-sm"
              />
            </div>

            {/* First + Last Name */}
            <div className="mb-4 flex gap-2">
              <div className="w-1/2">
                <label className="block text-sm text-text mb-1">
                  First name{" "}
                  {errors.firstName && touched.firstName && (
                    <span className="text-red-500">Required</span>
                  )}
                </label>
                <Field
                  name="firstName"
                  className="w-full border border-dry bg-drydark text-white placeholder-gray-400 rounded-md p-3 text-sm"
                />
              </div>
              <div className="w-1/2">
                <label className="block text-sm text-text mb-1">
                  Last name{" "}
                  {errors.lastName && touched.lastName && (
                    <span className="text-red-500">Required</span>
                  )}
                </label>
                <Field
                  name="lastName"
                  className="w-full border border-dry bg-drydark text-white placeholder-gray-400 rounded-md p-3 text-sm"
                />
              </div>
            </div>

            {/* Booking System */}
            <div className="mb-4">
              <label className="block text-sm text-text mb-1">
                How do you manage your booking{" "}
                {errors.bookingSystem && touched.bookingSystem && (
                  <span className="text-red-500">Required</span>
                )}
              </label>
              <Field
                as="select"
                name="bookingSystem"
                className="w-full border border-dry bg-drydark text-white placeholder-gray-400 rounded-md p-3 text-sm"
              >
                {bookingOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Field>
            </div>

            {/* Email */}
            <div className="mb-4">
              <label className="block text-sm text-text mb-1">
                Email{" "}
                {errors.email && touched.email && (
                  <span className="text-red-500">Required</span>
                )}
              </label>
              <Field
                name="email"
                type="email"
                className="w-full border border-dry bg-drydark text-white placeholder-gray-400 rounded-md p-3 text-sm"
              />
            </div>

            {/* Password */}
            <div className="mb-4">
              <label className="block text-sm text-text mb-1">
                Password{" "}
                {errors.password && touched.password && (
                  <span className="text-red-500">Required</span>
                )}
              </label>
              <Field
                name="password"
                type="password"
                className="w-full border border-dry bg-drydark text-white placeholder-gray-400 rounded-md p-3 text-sm"
              />
            </div>

            {/* Checkbox */}
            <div className="flex items-center mb-4">
              <Field type="checkbox" name="agree" className="mr-2" />
              <span className="text-xs text-textGray">
                I've read and agree to the{" "}
                <span className="text-redlight underline">Terms</span> and{" "}
                <span className="text-redlight underline">Privacy policy</span>
              </span>
            </div>
            {errors.agree && touched.agree && (
              <div className="text-xs text-red-500 mb-2">{errors.agree}</div>
            )}

            {/* Submit */}
            <button
              type="submit"
              className="w-full py-3 bg-redlight text-white rounded-md text-sm font-semibold"
            >
              Start my trial
            </button>

            {/* Country + Promo */}
            <p className="text-xs text-center mt-4 text-textGray">
              Country, currency and timezone <br />
              <span className="text-redlight font-medium">
                New Zealand, New Zealand Dollar, Pacific/Auckland.
              </span>
            </p>
            <p className="text-xs text-center mt-3 text-redlight underline cursor-pointer">
              Have a promo code?
            </p>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default RegisterStep3;
